import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Col,
  Spinner,
  FormText,
  Row,
} from "react-bootstrap";
import {
  CONSENT_ERROR,
  ERROR_LOADING_USER_PROFILE,
  ERROR_WHILE_SENDING_CONSENT,
} from "../../configurations/MessageConstants";
import Alert from "../common/Alert";
import {
  DANGER,
  ELECTRIC_PROVIDERS_LIST,
  EMPTY,
} from "../../configurations/Constants";
import UserService from "../../api-service/UserService";
import { StatusCodes } from "../../configurations/status-codes";

function ConsentPopup() {
  const [showConsentPopup, setShowConsentPopup] = useState(false);
  const [powerProviders, setPowerProviders] = useState(ELECTRIC_PROVIDERS_LIST);
  const [alertMessage, setAlertMessage] = useState(EMPTY);
  const [variant, setVariant] = useState(EMPTY);
  const [showAlert, setShowAlert] = useState(false);
  const [sendBtnClick, setSendBtnClick] = useState(false);
  const [validated, setValidated] = useState(false);
  const [activePowerProviders, setActivePowerProviders] = useState(0);
  const [hasPowerProviders, setHasPowerProviders] = useState(false);
  const [noPowerProviders, setNoPowerProviders] = useState(true);
  const [powerProviderError, setPowerProviderError] = useState(false);
  const [allPowerProviderChecked, setAllPowerProviderChecked] = useState(false);

  useEffect(() => {
    (async function () {
      await getUserProfileData();
    })();
  }, []);

  const getUserProfileData = async () => {
    try {
      const response = await UserService.getProfileInfo();
      const userProfileData = response.data.data;
      let powerProvidersValue = powerProviders;
      let activePowerProvidersValue = 0;
      powerProvidersValue.forEach((p) => {
        if (userProfileData.electric_power_provider[p.name]) {
          activePowerProvidersValue += 1;
        }
        p.isActive = userProfileData.electric_power_provider[p.name];
      });
      setShowConsentPopup(userProfileData.consent_granted === 0 ? true : false);
      setPowerProviders(powerProvidersValue);
      setActivePowerProviders(activePowerProvidersValue);
    } catch (error) {
      console.error(ERROR_LOADING_USER_PROFILE, error);
      setShowConsentPopup(false);
    }
  };

  const handleClose = () => {
    setShowConsentPopup(false);
  };

  const handleCloseAlert = () => {
    setAlertMessage(EMPTY);
    setVariant(EMPTY);
    setShowAlert(false);
  };

  const checkPowerProviderValidation = (e, selection) => {
    if (e.target.checked) {
      if (selection === "Yes") {
        setNoPowerProviders(true);
        setPowerProviderError(true);
        setHasPowerProviders(false);
      } else {
        setNoPowerProviders(false);
        setPowerProviderError(false);
        setHasPowerProviders(true);
        setActivePowerProviders(0);

        let powerProvidersValue = powerProviders.map((item) => ({
          ...item,
          isActive: false,
        }));
        setPowerProviders(powerProvidersValue);
      }

      let allPowerProviderCheckedValue = powerProviders.every(
        (item) => item.isActive
      );
      setAllPowerProviderChecked(allPowerProviderCheckedValue);
    } else {
      if (selection === "Yes") {
        let allPowerProviderChecked = powerProviders.filter(function (item) {
          return item.isActive === true;
        });
        if (allPowerProviderChecked.length === 0) {
          setPowerProviderError(true);
        }
        setNoPowerProviders(true);
        setHasPowerProviders(false);
      } else {
        setNoPowerProviders(false);
        setPowerProviderError(false);
        setHasPowerProviders(true);
        setActivePowerProviders(0);
      }
    }
  };

  const handleCheckboxChange = (e) => {
    let providerName = e.target.name;
    let checked = e.target.checked;
    let isInvalidState = false;
    isInvalidState = validatePowerProviders(
      powerProviders,
      providerName,
      checked
    );
    if (providerName === "selectAll") {
      setAllPowerProviderChecked(checked);
      let powerProvidersValue = powerProviders.map((item) => ({
        ...item,
        isActive: checked,
      }));
      setPowerProviders(powerProvidersValue);
    } else {
      let powerProvidersValue = powerProviders.map((item) =>
        item.name === providerName ? { ...item, isActive: checked } : item
      );
      setPowerProviders(powerProvidersValue);
      setAllPowerProviderChecked(powerProviders.every((item) => item.isActive));
    }
    setPowerProviderError(isInvalidState);
    if (noPowerProviders === true) {
      setPowerProviderError(false);
    }
  };

  const validatePowerProviders = (providers, providerName, checked) => {
    let selectedProviders = false;
    let currentPowerProviders = [];
    currentPowerProviders = providers.filter((item) => item.isActive);
    if (currentPowerProviders.length === 1 && checked === false) {
      selectedProviders = true;
    } else if (currentPowerProviders.length === 0 && checked === true) {
      selectedProviders = false;
    } else if (currentPowerProviders.length >= 1 && checked === true) {
      selectedProviders = false;
    } else if (currentPowerProviders.length > 1 && checked === false) {
      selectedProviders = false;
    } else {
      selectedProviders = true;
    }
    if (providerName === "selectAll" && checked === false) {
      selectedProviders = true;
    }
    if (noPowerProviders) {
      selectedProviders = true;
    }
    return selectedProviders;
  };

  const handleValidation = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      HandleSendConsent();
    }
    setValidated(true);
  };

  const HandleSendConsent = async () => {
    setSendBtnClick(true);
    try {
      let providers = {};
      powerProviders.map(
        (provider) => (providers[provider.name] = provider.isActive)
      );
      let payload = {
        authorized_electric_power_provider: providers,
      };
      if (noPowerProviders) {
        await UserService.updateProfileInfo(payload);
        setSendBtnClick(false);
        setShowConsentPopup(false);
      } else {
        setSendBtnClick(false);
        setShowConsentPopup(false);
      }
    } catch (error) {
      console.error(ERROR_WHILE_SENDING_CONSENT, error);
      if (error.response.status === StatusCodes.BAD_REQUEST) {
        setAlertMessage(CONSENT_ERROR);
        setVariant(DANGER);
        setShowAlert(true);
        setSendBtnClick(false);
      }
    }
  };

  const renderPowerProvidersList = (selectedPowerProviders) => {
    return powerProviders.map((item, index) => (
      <div key={item.id}>
        <FormText color="muted">
          <Form.Check
            type="checkbox"
            id={"chkpp" + index}
            name={item.name}
            value={item.name}
            checked={item.isActive}
            onChange={handleCheckboxChange}
            label={item.desc}
            disabled={!noPowerProviders}
            required={noPowerProviders && selectedPowerProviders.length === 0}
          />
        </FormText>
      </div>
    ));
  };

  let selectedPowerProviders = [];
  powerProviders.map((p) => {
    if (p.isActive === true) {
      selectedPowerProviders.push(EMPTY);
    }
    return true;
  });

  return (
    <Modal
      show={showConsentPopup}
      onHide={handleClose}
      className="authorization-consent"
    >
      <Form
        noValidate
        validated={validated}
        onSubmit={(e) => handleValidation(e)}
      >
        <Modal.Header closeButton>
          <Modal.Title className="ps-3">
            Electric Power Provider Authorization
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showAlert && (
            <Alert
              key="messageAlert"
              variant={variant}
              closeAlert={(e) => handleCloseAlert(e)}
              alertMessage={alertMessage}
              dismissible
            />
          )}
          <Row className="ps-3 mb-3 b">
            <FormText>
              <b>
                Update to Electric Power Provider Authorization – New
                Authorization
              </b>
            </FormText>
          </Row>
          <Row className="ps-3 pe-3 mb-3">
            <FormText color="muted">
              In order to better serve you as growers and the Twin Platte NRD,
              GiSC is actively engaged in providing irrigation data for past
              growing seasons. To accomplish this, GiSC will need electric
              records for power providers from those seasons. To ensure our
              commitment to growers data privacy and transparency, we are
              updating the Electric Power Provider Authorization, which provides
              authorization to power providers to release electric data to Twin
              Platte NRD & GiSC.
            </FormText>
          </Row>
          <Row className="ps-3 pe-3">
            <Form.Group as={Col} controlId="validationCustomspowerproviderterm">
              <FormText color="muted">
                <Form.Check
                  required={!hasPowerProviders}
                  name="terms"
                  label="I hereby give the Electric Power Providers selected below permission to release my electric data to Twin Platte NRD & GiSC. This permission includes the release of past, present, and future electric data so as to facilitate providing irrigation records for previous, present, and future growing seasons. This permission only includes data releases so long as this authorization for the Authorized Electric Power Provider remains in effect."
                  id="providerTerm"
                  checked={noPowerProviders}
                  onChange={(e) => checkPowerProviderValidation(e, "Yes")}
                />
              </FormText>
            </Form.Group>
          </Row>
          <Row className="ps-3 pe-3">
            <Form.Group
              as={Col}
              controlId="validationCustomsnopowerproviderterm"
            >
              <FormText color="muted">
                <Form.Check
                  required={!noPowerProviders}
                  name="terms"
                  label="I do not have any registered wells with electric power in the Twin Platte NRD."
                  id="noProviderTerm"
                  checked={hasPowerProviders}
                  onChange={(e) => checkPowerProviderValidation(e, "No")}
                />
              </FormText>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col} className="mb-0">
              <Form.Label>
                <strong>
                  Authorized Electric Power Provider
                  {noPowerProviders ? "*" : EMPTY}
                </strong>
              </Form.Label>
            </Form.Group>
          </Row>
          <Row className="ps-3 pe-3">
            <Form.Group as={Col}>
              <FormText color="muted">
                <strong>
                  <Form.Check
                    id="selectAll"
                    type="checkbox"
                    required={
                      noPowerProviders && selectedPowerProviders.length === 0
                        ? true
                        : false
                    }
                    disabled={!noPowerProviders}
                    name="selectAll"
                    checked={allPowerProviderChecked}
                    isInvalid={
                      noPowerProviders && activePowerProviders === 0
                        ? powerProviderError
                        : false
                    }
                    feedback="Please select at least one provider"
                    onChange={handleCheckboxChange}
                    label="Select All"
                  />
                </strong>
                {renderPowerProvidersList(selectedPowerProviders)}
              </FormText>
            </Form.Group>
          </Row>
          <Row className="ps-3 pe-3 mt-2">
            <FormText color="muted" className="authorization-consent-questions">
              * Questions, please contact TPNRD: (308) 535-8080
            </FormText>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            type="submit"
            className="d-block me-auto ms-3"
            disabled={sendBtnClick}
          >
            {sendBtnClick ? (
              <div>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                <span>{"Submitting..."}</span>
              </div>
            ) : (
              "Agree"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ConsentPopup;
